export default __webpack_public_path__ + "static/media/geographica.c95d759a.png";